// extracted by css-extract-rspack-plugin
export default {"root":"dZWtbv","cover":"RjxTkZ","middle":"kdy7Pt","centered-contents":"w6AQjY","centeredContents":"w6AQjY","underlay":"UftfQL","mature-block":"VJxtLs","matureBlock":"VJxtLs"};